import * as Yup from 'yup';
import { JobApplicationType } from '../../../domain/types';

export const jobApplicationFormSchema = Yup.object({
  applicationType: Yup.string().required(),
  provinces: Yup.array().when('applicationType', {
    is: JobApplicationType.SALES,
    then: (schema) => schema.min(1, 'Devi selezionare almeno una provincia'),
    otherwise: (schema) => schema.notRequired(),
  }),
  jobPosition: Yup
    .object({
      id: Yup.string().required('Il ruolo è richiesto'),
    }),
  source: Yup.string().required('La sorgente è obbligatoria'),
  experience: Yup.string().notRequired(),
  isEmployed: Yup.string().notRequired(),
  hasLicense: Yup.boolean().when('applicationType', {
    is: JobApplicationType.SALES,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.notRequired(),
  }),
  licenseId: Yup.string().notRequired(),
});
